export default __webpack_public_path__ + "static/media/reviews.4b42be2a.svg";